<script setup>
    /**
    * This parent component contains PaymentInfoShow and PaymentInfoEdit, as well
    * as state-managing logic to switch between each component on button press.
    * Those two components should be locally registered here, if possible.
    * State: 0 for PaymentInfoShow, 1 for PaymentInfoEdit.
    * Modeled after UserData.vue.
    */

    import { ref } from 'vue';
    import PaymentInfoShow from './PaymentInfoShow.vue';
    import PaymentInfoEdit from './PaymentInfoEdit.vue';

    const props = defineProps(['fetchUrl', 'updateUrl', 'userNumber', 'isAdmin']);
    const state = ref(0);
    const saveConfirm = ref(0);
    const saveError = ref();

</script>

<template>
    <h3>Zahlungsdaten</h3>
    <PaymentInfoShow
        v-if="state == 0"
        @switch-to-edit="state = 1, saveConfirm = 0, saveError = false"
        :fetchUrl="props.fetchUrl"
        :userNumber="props.userNumber"
        :isAdmin="props.isAdmin"
    />
    <PaymentInfoEdit
        v-if="state != 0"
        @switch-to-show="state = 0"
        @successful-save="saveConfirm = 1, saveError = false"
        @save-error="saveError = true, saveConfirm = 0"
        :fetchUrl="props.fetchUrl"
        :updateUrl="props.updateUrl"
        :userNumber="props.userNumber"
        :isAdmin="props.isAdmin"
    />

    <div class="alert alert-success" role="alert" v-if="saveConfirm != 0">
        Daten erfolgreich gespeichert!
    </div>
    <div class="alert alert-danger" role="alert" v-if="saveError === true">
        Leider ist ein Fehler passiert. Wir bitten um Entschuldigung.
    </div>

</template>
